import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import {
  showActiveContestPopUp,
  setSignupFlow,
  setContestStep
} from '../../actions/contest';

class VoteItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      voteItemDetail,
      showActiveContestPopUp,
      setSignupFlow,
      signedIn,
      hasVoted
    } = this.props;

    // If user signed in but havent voted yet
    if (!hasVoted && signedIn) {
      setContestStep('voting');
    }

    const percentage = voteItemDetail.result_vote;
    let value = 0;
    if (percentage) {
      if (Number.isInteger(percentage)) {
        value = percentage;
      } else {
        value = percentage.toFixed(0);
      }
    }

    return (
      <div className='vote-item'>
        <div className='fe-trip-item-info-main'>
          <div className='fe-u-thumb-4by3 fe-rounded'>
            <img
              onClick={() => {
                if (!hasVoted) {
                  showActiveContestPopUp(voteItemDetail.id, true);
                }
              }}
              className={`trip-item-img ${hasVoted ? 'readonly' : ''}`}
              src={voteItemDetail.images.cover[0].image_url}
              alt=''
            />
          </div>
          <div className='info'>
            <span>{voteItemDetail.title}</span>
          </div>
        </div>
        <div className='cta-container'>
          <div
            className={`fe-u-btnlink  ${hasVoted ? 'readonly' : ''}`}
            onClick={() => {
              if (!hasVoted) {
                showActiveContestPopUp(voteItemDetail.id, true);
              }
            }}
          >
            {!hasVoted ? 'Tell Me More' : `${value}%`}
          </div>
        </div>
      </div>
    );
  }
}

VoteItem.propTypes = {
  showActiveContestPopUp: PropTypes.func,
  voteItemDetail: PropTypes.object,
  signedIn: PropTypes.bool.isRequired,
  setContestStep: PropTypes.func
};

const mapStateToProps = ({ authState }) => ({
  signedIn: authState.signedIn
});

const mapDispatchToProps = {
  showActiveContestPopUp,
  setSignupFlow,
  setContestStep
};

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(VoteItem)
);
